<template>
  <div class="card bg-light mb-3">
    <div class="card-header">
      <h5 class="card-title">
        <i class="fa fa-users"></i>
        Default Members
      </h5>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-12 col-md-6">
          <SingleGroup :group="group" v-for="group in getGroupsForColumn(0)" :key="group.id"></SingleGroup>
          <button class="btn btn-sm mt-2" @click="newGroup.column = 0; $refs.addGroupModel.open()">
            <i class="fa fa-plus"></i> {{ $t('UI_INSTANCE_MEMBER_GROUP_ADD') }}
          </button>
        </div>
        <div class="col-12 col-md-6">
          <SingleGroup :group="group" v-for="group in getGroupsForColumn(1)" :key="group.id"></SingleGroup>
          <button class="btn btn-sm mt-2" @click="newGroup.column = 1; $refs.addGroupModel.open()">
            <i class="fa fa-plus"></i> {{ $t('UI_INSTANCE_MEMBER_GROUP_ADD') }}
          </button>
        </div>
      </div>
    </div>

    <!-- Create Member Group-->
    <sweet-modal :title="$t('UI_INSTANCE_MEMBER_GROUP_ADD')" ref="addGroupModel">
      <div class="form-group">
        <label for="title">{{ $t("UI_INSTANCE_MEMBER_GROUP_TITLE") }}</label>
        <input type="text" id="title" v-model="newGroup.title" :placeholder="$t('UI_INSTANCE_MEMBER_GROUP_TITLE')" class="form-control">
      </div>

      <div class="form-group">
        <label for="columnGroup">{{ $t('UI_INSTANCE_MEMBER_GROUP_COLUMN') }}</label><br>
        <div class="btn-group" id="columnGroup">
          <button class="btn btn-outline-dark" :class="{'btn-dark text-white': newGroup.column === 0}" @click="newGroup.column = 0">
            {{ $t('UI_INSTANCE_MEMBER_GROUP_COLUMN_LEFT') }}
          </button>
          <button class="btn btn-outline-dark" :class="{'btn-dark text-white': newGroup.column === 1}" @click="newGroup.column = 1">
            {{ $t('UI_INSTANCE_MEMBER_GROUP_COLUMN_RIGHT') }}
          </button>
        </div>
      </div>

      <div class="form-group">
        <label for="color">{{ $t('UI_INSTANCE_MEMBER_GROUP_COLOR') }}</label>
        <swatches v-model="newGroup.color" id="color" inline></swatches>
      </div>


      <div slot="button">
        <button class="btn btn-primary" @click="addGroupToChannel">
          {{ $t("UI_MODAL_BUTTON_CREATE") }}
        </button>
        <button class="btn btn-secondary ml-1" @click="$refs.addGroupModel.close()">
          {{ $t("UI_MODAL_BUTTON_CLOSE") }}
        </button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';
import { Swatches } from 'vue-swatches';
import { RepositoryFactory } from '../../../../../repositories/RepositoryFactory';
import SingleGroup from './SingleGroup';

const ChannelMemberRepository = RepositoryFactory.get('channelMembers');

export default {
  name: 'DefaultMembers',
  components: { SingleGroup, SweetModal, Swatches },
  data() {
    return {
      newGroup: {
        title: '',
        column: 0,
        color: null,
      },
	    moving: {
		    sourceGroup: null,
		    targetGroup: null,
		    targetPosition: null,
	    },
    };
  },
  mounted() {
    this.refetchMemberList();
  },
  watch: {
    currentChannelId(newId, oldId) {
      this.refetchMemberList();
    },
  },
  methods: {
	    /**
	     * Adds a group to the Instance
	     * @returns {Promise<boolean>}
	     */
	    async addGroupToChannel() {
		    if (this.newGroup.title.length < 1) {
			    this.$snotify.error(this.$t('UI_INSTANCE_MEMBER_GROUP_TITLE_REQUIRED'));
			    return false;
		    }

		    await ChannelMemberRepository.addGroup(this.newGroup.title, this.newGroup.column, this.newGroup.color).then(() => {
			    this.$snotify.info(this.$t('UI_INSTANCE_MEMBER_GROUP_ADDED', { name: this.newGroup.title }));
			    this.newGroup = {};
			    ChannelMemberRepository.refetchMemberList();
			    this.$refs.addGroupModel.close();
		    });
	    },

	    /**
	     * Fetches the current Member list and pushes changes to the Store.
	     *
	     * @returns {Promise<void>}
	     */
	    async refetchMemberList() {
		    await ChannelMemberRepository.refetchMemberList();
	    },

	    /**
	     * Returns the Member groups that belong to the column $col
	     * @param col
	     * @returns {*}
	     */
	    getGroupsForColumn(col) {
	    	if (this.memberLists === null) { return null; }
		    if (!this.memberLists.length) { return null; }
		    return this.memberLists.filter(group => group.column === col);
	    },
  },
  computed: {
	    memberLists() {
		    return this.$store.getters.activeChannelMemberList;
	    },
    currentChannelId() {
      return this.$store.state.currentChannelId;
    },
  },
};
</script>

<style scoped>

</style>
